module.exports = __webpack_public_path__ + "static/media/robot fall.60869391.gif";